var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFocusSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8787 4.04553C16.5825 4.04553 15.8584 5.35462 16.1534 6.32734L12.9799 9.56368C12.7117 9.48187 12.3184 9.48187 12.0502 9.56368L9.7707 7.24552C10.0746 6.27279 9.35055 4.95462 8.04541 4.95462C6.7492 4.95462 6.01618 6.2637 6.32012 7.24552L2.24378 11.3819C1.28727 11.0819 0 11.8182 0 13.1364C0 14.1364 0.804541 14.9546 1.78787 14.9546C3.08407 14.9546 3.80816 13.6455 3.51316 12.6728L7.58056 8.52733C7.84874 8.60914 8.24208 8.60914 8.51026 8.52733L10.7898 10.8455C10.4859 11.8182 11.2099 13.1364 12.5151 13.1364C13.8113 13.1364 14.5443 11.8273 14.2404 10.8455L17.4228 7.61824C18.3793 7.91824 19.6666 7.18188 19.6666 5.8637C19.6666 4.86371 18.862 4.04553 17.8787 4.04553Z",
    fill: "#9D9DE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2916 5L13.0619 3.275L14.7499 2.5L13.0619 1.725L12.2916 0L11.5377 1.725L9.83325 2.5L11.5377 3.275L12.2916 5Z",
    fill: "#9D9DE3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86795 6.66667L3.27767 5L4.91656 4.58333L3.27767 4.16667L2.86795 2.5L2.45822 4.16667L0.819336 4.58333L2.45822 5L2.86795 6.66667Z",
    fill: "#9D9DE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusSmallIcon);
export default __webpack_public_path__ + "static/media/focus-small-icon.b7b381f0.svg";
export { ForwardRef as ReactComponent };